import { inject, ref, watch } from 'vue';

/**
 * Wire a per-system doc section to the deep-link machinery in Index.vue.
 *
 * Usage in a per-system .vue file:
 *   const { sectionId, accordionActive } = useHelpSection('links-myaffiliates');
 *   // Template:
 *   <section :id="sectionId">
 *     <Accordion v-model:activeIndex="accordionActive">...
 *
 * Behaviour:
 *  - If `?section=<slug>` matches this component's slug (on mount or on route
 *    change), the accordion's first tab is auto-expanded so the linked content
 *    is visible. User can still collapse it manually afterwards.
 *  - Deriving from a shared injected `activeHelpSection` ref (provided by
 *    Index.vue) so URL → UI stays in sync as the query param changes without
 *    a full page reload.
 *
 * @param {string} slug — canonical URL slug for this section (e.g. 'links-myaffiliates')
 */
export function useHelpSection(slug) {
    const activeSection = inject('activeHelpSection', ref(''));
    const accordionActive = ref([]);

    watch(activeSection, (v) => {
        if (v === slug) accordionActive.value = [0];
    }, { immediate: true });

    return {
        sectionId: `section-${slug}`,
        accordionActive,
    };
}
